import { render, staticRenderFns } from "./FocusTutorialOverlay.vue?vue&type=template&id=39e458ee&scoped=true"
import script from "./FocusTutorialOverlay.vue?vue&type=script&lang=js"
export * from "./FocusTutorialOverlay.vue?vue&type=script&lang=js"
import style0 from "./FocusTutorialOverlay.vue?vue&type=style&index=0&id=39e458ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e458ee",
  null
  
)

export default component.exports